import lodash from 'lodash'
import Helper from '@/Helper'
export default {
  getListCtg (state, payload) {
    state.list_category_chk_recursive = Helper.recursiveDocItem(payload, 0)
    state.list_category_chk = payload
  },
  createCtg (state, payload) {
    state.list_category_chk.push(payload)
    state.list_category_chk_recursive = Helper.recursiveDocItem(state.list_category_chk, 0)
  },
  destroyCtg (state, payload) {
    var index = lodash.findIndex(state.list_category_chk, ['id', payload.id])
    state.list_category_chk.splice(index, 1)
  }

}



// WEBPACK FOOTER //
// ./src/store/module/category-chk/mutations.js